import { $t } from "@/plugins/i18n";
import { aiLive } from "@/router/enums";
import sound from "@/assets/svg/sound.svg?component";
import liveRoom from "@/assets/svg/live_room.svg?component";
import product from "@/assets/svg/product.svg?component";
import homeIcon from "@/assets/svg/home.svg?component";

const { VITE_HIDE_HOME } = import.meta.env;

export default {
  path: "/aiLive",
  redirect: "/myProject/index",
  meta: {
    icon: liveRoom,
    title: $t("menus.aiLive"), // 建议多语言
    rank: aiLive,
    // 隐藏直播相关菜单（路由仍保留，可通过地址直接访问）
    showLink: false
  },
  children: [
    {
      path: "/welcome",
      name: "Welcome",
      component: () => import("@/views/welcome/index.vue"),
      meta: {
        title: $t("menus.experienceLiveRoom"),
        icon: homeIcon,
        showLink: VITE_HIDE_HOME === "true" ? false : true
      }
    },
    {
      path: "/myProject/index",
      name: "myProject",
      component: () => import("@/views/myProject/index.vue"),
      meta: {
        title: $t("menus.myProject"),
        icon: product
        // keepAlive: false
      }
    },
    {
      path: "/myLiveRoom/index",
      name: "myLiveRoom",
      component: () => import("@/views/myLiveRoom/index.vue"),
      meta: {
        title: $t("menus.myLiveRoom"),
        icon: liveRoom
        // keepAlive: false
      }
    },
    {
      path: "/speechLibrary/index",
      name: "SpeechLibrary",
      component: () => import("@/views/clonedVoiceLib/index.vue"),
      meta: {
        icon: sound,
        title: $t("menus.speechLibrary")
        // keepAlive: false
      }
    }
  ]
} satisfies RouteConfigsTable;
